import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import RouteursCis from './configuration/cis/RouteursCis';
import RouteursDesk from "./configuration/desk/RouteursDesk";
import {useGetMe} from "../../hooks/useGetMe";
import {isClientCIS} from "../../../Domains/Auth/Utils/CustomerHelper";

const ConfigurationList = (): JSX.Element => {
    const intl = useIntl();
    const customer = useGetMe();

    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CONFIGURATION'})}</PageTitle>
            {customer && (isClientCIS(customer) ? <RouteursCis /> : <RouteursDesk />)}
        </>
    );
};

export default ConfigurationList;
